export const womenreproductiveModuleOverview = [
  {
    id: "anatomy",
    title: "Women Reproductive Anatomy",
    description: "Learn the structure of the women reproductive system",
    icon: "❤️",
    customImage: "module-womanreproductive-anatomy.png",
    gradient: "from-green-300 via-green-50 to-rose-100 border-green-500",
  },
  {
    id: "histology",
    title: "Women Reproductive Histology",
    description: "Microscopic structure of the women reproductive system",
    icon: "🔬",
    customImage: "module-womanreproductive-anatomy.png",
    gradient: "from-green-100 via-green-50 to-rose-100 border-green-500",
  },
  {
    id: "physiology",
    title: "Female Reproductive Physiology",
    description: "Hormonal regulation and cycles",
    icon: "⚡",
    gradient: "from-green-300 via-green-50 to-rose-100 border-green-500",
  },
];
